import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { FTCDisclosureModal } from "@/sales-tools/disclosures/components/FTCDisclosureModal";
import { useMostRecentTask } from "@/sdk";

// Global ref to store the open function
export const disclosureModalRef = {
    current: null as ((productSku: string, requiresNyDisclosures: boolean) => void) | null,
};

export function DisclosureModalController() {
    const [opened, { open, close }] = useDisclosure(false);
    const task = useMostRecentTask();
    const language = task?.locale === "es-mx" ? "es-US" : "en-US";
    const [modalData, setModalData] = useState<{ productSku: string; requiresNyDisclosures: boolean } | null>(null);

    useEffect(() => {
        // Store the open function in the global ref
        disclosureModalRef.current = (productSku: string, requiresNyDisclosures: boolean) => {
            setModalData({ productSku, requiresNyDisclosures });
            open();
        };

        return () => {
            disclosureModalRef.current = null;
        };
    }, [open]);

    if (!modalData) return null;

    return (
        <FTCDisclosureModal
            opened={opened}
            close={() => {
                close();
                setModalData(null);
            }}
            productSku={modalData.productSku}
            language={language}
            requiresNyDisclosures={modalData.requiresNyDisclosures}
        />
    );
}
